import { render, staticRenderFns } from "./land-info.html?vue&type=template&id=2784500f&scoped=true&external"
import script from "./land-info.js?vue&type=script&lang=js&external"
export * from "./land-info.js?vue&type=script&lang=js&external"
import style0 from "./land-info.scss?vue&type=style&index=0&id=2784500f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784500f",
  null
  
)

export default component.exports